import { create } from 'zustand'
import { getStorageConfig, type StorageConfig } from '../services/api'

interface StorageConfigState {
  config: StorageConfig | null
  isLoading: boolean
  isInitialized: boolean
  initConfig: () => Promise<void>
  refreshConfig: () => Promise<void>
}

export const useStorageConfigStore = create<StorageConfigState>((set, get) => ({
  config: null,
  isLoading: false,
  isInitialized: false,

  initConfig: async () => {
    // 如果已经初始化过或正在加载，直接返回
    if (get().isInitialized || get().isLoading) {
      console.log('📦 存储配置已初始化或正在加载，跳过')
      return
    }

    console.log('📦 开始初始化存储配置...')
    set({ isLoading: true })
    try {
      const config = await getStorageConfig()
      console.log('📦 获取到存储配置:', config)
      const finalConfig = config || { useOSS: false, provider: 'aliyun', bucket: null, region: null, endpoint: null }
      set({
        config: finalConfig,
        isLoading: false,
        isInitialized: true
      })
      console.log('📦 存储配置初始化完成:', finalConfig)
    } catch (error) {
      console.error('❌ 初始化存储配置失败:', error)
      set({
        config: { useOSS: false, provider: 'aliyun', bucket: null, region: null, endpoint: null },
        isLoading: false,
        isInitialized: true
      })
    }
  },

  refreshConfig: async () => {
    set({ isLoading: true })
    try {
      const config = await getStorageConfig()
      set({
        config: config || { useOSS: false, provider: 'aliyun', bucket: null, region: null, endpoint: null },
        isLoading: false
      })
    } catch (error) {
      console.error('刷新存储配置失败:', error)
      set({ isLoading: false })
    }
  }
}))
